var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button, IconButton, } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CopyIcon from '@mui/icons-material/ContentCopy';
import RemoveIcon from '@mui/icons-material/Remove';
import SaveIcon from '@mui/icons-material/Save';
import { getSubmitButtonOptions, } from '@rjsf/utils';
import { useTranslate } from 'react-admin';
var MuiIconButton = function (props) {
    var icon = props.icon, color = props.color, uiSchema = props.uiSchema, registry = props.registry, otherProps = __rest(props, ["icon", "color", "uiSchema", "registry"]);
    return (React.createElement(IconButton, __assign({}, otherProps, { size: "small", color: color }), icon));
};
var AddButton = function (_a) {
    var uiSchema = _a.uiSchema, registry = _a.registry, props = __rest(_a, ["uiSchema", "registry"]);
    var translate = useTranslate();
    return (React.createElement(IconButton, __assign({ title: translate('ra.action.add', { _: 'Add' }) }, props, { color: "primary" }),
        React.createElement(AddIcon, null)));
};
var CopyButton = function (props) {
    var translate = useTranslate();
    return (React.createElement(MuiIconButton, __assign({ title: translate('ra.action.copy', { _: 'Copy' }) }, props, { icon: React.createElement(CopyIcon, { fontSize: "small" }) })));
};
var MoveDownButton = function (props) {
    var translate = useTranslate();
    return (React.createElement(MuiIconButton, __assign({ title: translate('ra.action.move_down', { _: 'Move down' }) }, props, { icon: React.createElement(ArrowDownwardIcon, { fontSize: "small" }) })));
};
var MoveUpButton = function (props) {
    var translate = useTranslate();
    return (React.createElement(MuiIconButton, __assign({ title: translate('ra.action.move_up', { _: 'Move up' }) }, props, { icon: React.createElement(ArrowUpwardIcon, { fontSize: "small" }) })));
};
var RemoveButton = function (props) {
    var iconType = props.iconType, otherProps = __rest(props, ["iconType"]);
    var translate = useTranslate();
    return (React.createElement(MuiIconButton, __assign({ title: translate('ra.action.remove', { _: 'Remove' }) }, otherProps, { color: "error", icon: React.createElement(RemoveIcon, { fontSize: iconType === 'default' ? undefined : 'small' }) })));
};
var SubmitButton = function (_a) {
    var uiSchema = _a.uiSchema;
    var _b = getSubmitButtonOptions(uiSchema), norender = _b.norender, _c = _b.props, submitButtonProps = _c === void 0 ? {} : _c;
    var translate = useTranslate();
    if (norender) {
        return null;
    }
    return (React.createElement(Button, __assign({ type: "submit", variant: "contained", color: "primary", sx: { mt: 3 } }, submitButtonProps, { startIcon: React.createElement(SaveIcon, null) }), translate('ra.action.save', { _: 'Save' })));
};
export default {
    AddButton: AddButton,
    CopyButton: CopyButton,
    MoveDownButton: MoveDownButton,
    MoveUpButton: MoveUpButton,
    RemoveButton: RemoveButton,
    SubmitButton: SubmitButton,
};
